// ----------------------------------------------------------------------------
// Snippet: Shopify Predictive Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_predictive-search.scss';

const SEARCH_FORM = '.search-box';
const PREDICTIVE_SEARCH= '.predictive-search';
const SEARCH_OVERLAY = '#search-overlay';

document.body.addEventListener('click', function(event) {

    const element = event.target;

    if (element.closest(SEARCH_FORM) == null) {
        const predictiveSearchResults = document.querySelectorAll(PREDICTIVE_SEARCH);
        const searchOverlay = document.querySelector(SEARCH_OVERLAY);

        searchOverlay.style.display = 'none';

        predictiveSearchResults.forEach((predictiveSearchResult) => {
            predictiveSearchResult.style.display = 'none';
        });
    }
});
